import React from 'react'
import { FaFacebookF, FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { contactImg } from "../../assets/index";

const ContactLeft = () => {
  return (
    <div className="w-full lgl:w-[35%] h-full bg-gradient-to-r from-[#1e2024] to-[#23272b] p-4 lgl:p-8 rounded-lg shadow-shadowOne flex flex-col gap-8 justify-center">
      <img
        className="w-full h-64 object-cover rounded-lg mb-2"
        src={contactImg}
        alt="contactImg"
      />
      <div className="flex flex-col gap-4">
        <h3 className="text-3xl font-bold text-white">Surya A</h3>
        <p className="text-lg font-normal text-gray-400">
          Software Developer L2
        </p>
        <p className="text-base text-gray-400 tracking-wide">
          Front-End Developer with 3.6 years of experience in building scalable, responsive, and high performance web applications. Skilled in Angular, React, and Vue.js with strong expertise in 
JavaScript, TypeScript, SCSS, and Tailwind CSS. Adept at creating seamless user experiences and collaborating with cross-functional teams to deliver innovative solutions. Passionate about staying up-to-date with the latest industry trends and continuously improving development skills.
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Phone: <span className="text-lightText">9345641736</span>
        </p>
        <p className="text-base text-gray-400 flex items-center gap-2">
          Email: <span className="text-lightText">a.surya1982002@gmail.com</span>
        </p>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className="text-base uppercase font-titleFont mb-4">Find me in</h2>
        <div className="flex gap-4">
          <span className="bannerIcon">
            <FaFacebookF />
          </span>
          <span className="bannerIcon">
            <FaTwitter />
          </span>
          <a
            href="https://linkedin.com/in/surya-a-77357b2a6"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="bannerIcon">
              <FaLinkedinIn />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
}

export default ContactLeft